import axios from "axios";
import {
    Chart
} from "frappe-charts/dist/frappe-charts.min.esm"

let dailyApplicationGraph = document.querySelector('#daily_application_graph .chart');

if (dailyApplicationGraph) {

    axios.get('/graph?graph=daily_application_graph')
        .then(function (response) {

            let data = response.data;


            let chart = new Chart(dailyApplicationGraph, {
                type: 'line',
                height: 200,
                colors: ['#2860F6'],
                data: data,
                barOptions: {
                    spaceRatio: 0.2 // default: 1
                },
                tooltipOptions: {
                    formatTooltipY: d => d + ' başvuru',
                }
            });
        });

}

let dailyApplicationIncomeGraph = document.querySelector('#daily_application_income_graph .chart');

if (dailyApplicationIncomeGraph) {

    axios.get('/graph?graph=daily_application_income_graph')
        .then(function (response) {

            let data = response.data;


            let chart = new Chart(dailyApplicationIncomeGraph, {
                type: 'bar',
                height: 200,
                colors: ['#82C43C'],
                data: data,
                barOptions: {
                    spaceRatio: 0.2 // default: 1
                },
                tooltipOptions: {
                    // formatTooltipX: d => (d + '').toUpperCase(),
                    formatTooltipY: d => d + ' TL',
                }
            });
        });

}

let guestsGraph = document.querySelector('#guests_graph .chart');

if (guestsGraph) {

    axios.get('/graph?graph=guests_graph')
        .then(function (response) {

            let data = response.data;


            let chart = new Chart(guestsGraph, {
                type: 'heatmap',
                title: 'Guests Map',
                data: {
                    'dataPoints': data['dataPoints'],
                    'start': new Date(data['start']),
                    'end': new Date(data['end'])
                },
                countLabel: 'Misafir',
                colors: ['#ebedf0', '#c0ddf9', '#73b3f3', '#3886e1', '#17459e'],
            });
        });

}